export default "__VITE_ASSET__DxcC4HMK__"